import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type Props = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
};

export default function PageHeader({ title, subtitle, action }: Props): JSX.Element {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 2, sm: 3 }}
      alignItems={{ xs: 'stretch', sm: 'flex-start' }}
      justifyContent="space-between"
      sx={{ mb: { xs: 2.5, sm: 3.5 } }}
    >
      <Box sx={{ minWidth: 0, maxWidth: 720 }}>
        <Typography variant="h4" sx={{ mb: subtitle ? 0.75 : 0, color: 'text.primary' }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 680 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {action ? (
        <Box
          sx={{ display: 'flex', justifyContent: { xs: 'stretch', sm: 'flex-end' }, flexShrink: 0 }}
        >
          {action}
        </Box>
      ) : null}
    </Stack>
  );
}
